interface ClearErrorOptions {
  code?: string | null;
  forElement?: string | null;
  context?: string | null;
}

type ClearErrorAction = { type: 'CLEAR_ERROR' } & ClearErrorOptions;
type ClearAllErrorsAction = { type: 'CLEAR_ALL_ERRORS' };
type ErrorAction = ClearErrorAction | ClearAllErrorsAction;
type SharedDispatch = (action: ErrorAction) => ErrorAction;

export const clearError =
  ({ code = null, forElement = null, context = null }: ClearErrorOptions) =>
  (dispatch: SharedDispatch): void => {
    dispatch({ type: 'CLEAR_ERROR', code, forElement, context });
  };

export const clearAllErrors =
  () =>
  (dispatch: SharedDispatch): void => {
    dispatch({ type: 'CLEAR_ALL_ERRORS' });
  };

export default {
  clearError,
  clearAllErrors,
};
